import { InputHTMLAttributes } from 'react';

import styled from '@emotion/styled';

import COLOR from '../../shared/constant/colorset';

const Link = styled.a`
  height: 32px;
  padding: 6px 16px;
  border-radius: 18px;
  border: solid 1px ${COLOR.kurlyGray200};
  color: ${COLOR.kurlyGray600};
  font-size: 13px;
  line-height: 16px;;
  letter-spacing: -.32px;
`;

const PurpleText = styled.span`
  font-weight: 500;
  color: ${COLOR.kurlyPurple};
`;

export default function DeliveryGuideLink(
  props: InputHTMLAttributes<HTMLAnchorElement>,
) {
  return (
    <Link
      href="/shop/event/kurlyEvent.php?htmid=event/delivery_search/delivery_search"
      {...props}
    >
      <PurpleText>샛별・낮</PurpleText>
      {' '}
      배송안내
    </Link>
  );
}
